import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Button, message } from 'antd';
import { Link, useHistory } from 'react-router-dom';

import { useRecoilState, useRecoilValue } from 'recoil';
import { metamaskState } from 'global/state';

import Header from 'components/Header';
import { Title, Network } from 'components/utils';
import web3 from 'global/web3';


const Home = (props) => {
  const history = useHistory();
  const [ metamask, setMetamask ] = useRecoilState(metamaskState);

  // connect to metamask
  const connectToMetaMask = async () => {
    if ( window.ethereum ) {
      try {
        const response = await window.ethereum.enable();
        if ( response && response.length > 0 ) {
          const address = response[0];
          const network = window.ethereum.networkVersion;
          const networkId = network ? parseInt(network) : parseInt(await web3.eth.net.getId());

          if ( networkId !== Network.BSC && networkId !== Network.ETHEREUM ) {
            message.error('Error: Please select a Valid Network');
            return;
          }
          setMetamask({
            connected: true,
            address: address,
            network: networkId,
          });

          if ( networkId === Network.BSC ) {
            message.success('Successfully Connected to Binance Smart Chian Network!');
            history.push('/binance-smart-chain');
          } else if ( networkId === Network.ETHEREUM ) {
            message.success('Successfully Connected to Ethereum Network!');
            history.push('/ethereum');
          }

        }
      } catch (error) {
        console.log('error', error)
        message.error(`Error occured: ${error}`);
      }
    }
  }


  // return the output
  return (
    <div>
      <Header />

      <ContentContainer>
        <Title>Create Your Own ERC-20 Ethereum / Binance Smart Chain Network Token</Title>

        { metamask && ! metamask?.connected &&
        <ConnectToWallet>
          <p>Before we get started, Please connect to your wallet. For now we only support Metamask Extension!</p>
          <p>We currently support <strong>Ethereum</strong> and <strong>Binance Smart Chain</strong> Networks as of now.</p>
          <Button type="primary" style={{ fontWeight: 700 }} block onClick={ connectToMetaMask }>Connect to MetaMask</Button>
        </ConnectToWallet>
        }

        { metamask && metamask?.connected &&
          <ConnectToWallet>
            <p>Select the network you want to create and launch your token on</p>
            <Link to="/binance-smart-chain"><Button style={{ fontWeight: 700, height: 40 }} type="primary" block>Binance Smart Chain</Button></Link>
            <Link to="/ethereum"><Button style={{ fontWeight: 700, marginTop: 10, height: 40 }} type="primary" block>Ethereum Network</Button></Link>
        </ConnectToWallet>

        }

      </ContentContainer>
    </div>
  )
}

export default Home;


const ContentContainer = styled.div`
  margin-top: 100px;
  max-width: 500px;
  margin: 0 auto;
  padding: 30px 40px;

  background: rgb(25, 27, 31);
  box-shadow: rgb(0 0 0 / 1%) 0px 0px 1px, rgb(0 0 0 / 4%) 0px 4px 8px, rgb(0 0 0 / 4%) 0px 16px 24px, rgb(0 0 0 / 1%) 0px 24px 32px;
  border-radius: 10px;
  margin-top: 20px;
  min-height: 100px;

`;

const ConnectToWallet = styled.div`
  margin-top: 20px;
  border: 1px solid #434b5a;
  padding: 30px;
  border-radius: 5px;

  p {
    font-size: 16px;
    line-height: 20px;
    font-family: 'Balsamiq Sans', cursive;
    color: #2196f3;
  }

  strong { text-decoration: underline; }

`;

